// export const validateFields = async values => {
const validateFields = async values => {
  let errors = {};  

  /*** Client Fields */
  /*** Intake & Assessment */
  if (values.clientrecidivismriskscorenumber.length < 1) {
    errors.clientrecidivismriskscorenumber = 'Required';
    errors.notifyFormErrors = 'Intake & Assessment Tab - Client Recidivism Risk Score - Required';
    throw errors;
  } else if (!/[0-9999.]$/g.test(values.clientrecidivismriskscorenumber)) {
    errors.clientrecidivismriskscorenumber = 'Required';
    errors.notifyFormErrors = 'Intake & Assessment Tab - Client Recidivism Risk Score - Required';
    throw errors;
  } else if (!values.supportsystemcomments) {
    errors.supportsystemcomments = 'Required';
    errors.notifyFormErrors = 'Intake & Assessment Tab - Social Determinant Factors Tab - Support System Comments - Required';
    throw errors;
    
    /*** RRC Program */
    } else if (values.program === '1' && !values.clientrrchdeligibilitydate) {
        errors.clientrrchdeligibilitydate = 'Required';
        errors.notifyFormErrors = 'Intake & Assessment Tab - Wellness Tab - (RRC) HD Eligibility Date - Required';
        throw errors;

  /*** Crosspoint Programing */
  } else if (values.clientcbtprogramminghourscomplete.length < 1) {
    errors.clientcbtprogramminghourscomplete = 'Required';
    errors.notifyFormErrors = 'Crosspoint Programing Tab - Client CBT Programming Hours Complete - Required';
    throw errors;
  } else if (!/[0-9999.]$/g.test(values.clientcbtprogramminghourscomplete)) {
    errors.clientcbtprogramminghourscomplete = 'Required';
    errors.notifyFormErrors = 'Crosspoint Programing Tab - Client CBT Programming Hours Complete - Required';
    throw errors;


  /*** Voluntary Program Activities */
  } else if (values.clientcommunityvolunteerprojectscompleted.length < 1) {
    errors.clientcommunityvolunteerprojectscompleted = 'Required';
    errors.notifyFormErrors = 'Voluntary Program Activities Tab - Client Community Volunteer Projects Completed - Required';
    throw errors;
  } else if (!/[0-9999]$/g.test(values.clientcommunityvolunteerprojectscompleted)) {
    errors.clientcommunityvolunteerprojectscompleted = 'Required';
    errors.notifyFormErrors = 'Voluntary Program Activities Tab - Client Community Volunteer Projects Completed - Required';
    throw errors;

  } else if (values.clientadulteducation === '1' && !values.clientadulteducationcomments) {
    errors.clientadulteducationcomments = 'Required';
    errors.notifyFormErrors = 'Voluntary Program Activities Tab - Client Crosspoint Adult Education Activities During Stay Comments - Required';
    throw errors;

  /*** Discharge / Termination */
  /*** is the date populated */
  // } else if (values.clientdischargedate && values.clientdischargedate !== 'Invalid date' && !values.clientdischargezipcode) {
  } else if (values.clientdischargedate && !values.clientdischargezipcode) {
    errors.clientdischargezipcode = 'Required';
    errors.notifyFormErrors = 'Discharge / Termination Tab - Client Discharge Zip Code - Required';
    throw errors;
  // } else if (values.clientdischargedate && values.clientdischargedate !== 'Invalid date' && values.clientearningshourlyrate.length < 1) {
  } else if (values.clientdischargedate && values.clientearningshourlyrate.length < 1) {
    errors.clientearningshourlyrate = 'Required';
    errors.notifyFormErrors = 'Discharge / Termination Tab - Client Earnings Hourly Rate - Required';
    throw errors;
  // } else if (values.clientdischargedate && values.clientdischargedate !== 'Invalid date' && !/[0-9999]$/g.test(values.clientearningshourlyrate)) {
  } else if (values.clientdischargedate && !/[0-9999]$/g.test(values.clientearningshourlyrate)) {
    errors.clientearningshourlyrate = 'Required';
    errors.notifyFormErrors = 'Discharge / Termination Tab - Client Earnings Hourly Rate - Required';
    throw errors;
  // } else if (values.clientdischargedate && values.clientdischargedate !== 'Invalid date' && values.clientgrosssavings.length < 1) {
  } else if (values.clientdischargedate && values.clientgrosssavings.length < 1) {
    errors.clientgrosssavings = 'Required';
    errors.notifyFormErrors = 'Discharge / Termination Tab - Client Gross Savings - Required';
    throw errors;
  // } else if (values.clientdischargedate && values.clientdischargedate !== 'Invalid date' && !/[0-9999]$/g.test(values.clientgrosssavings)) {
  } else if (values.clientdischargedate && !/[0-9999]$/g.test(values.clientgrosssavings)) {
    errors.clientgrosssavings = 'Required';
    errors.notifyFormErrors = 'Discharge / Termination Tab - Client Gross Savings - Required';
    throw errors;

    /*** RRC Program */
    /*** BOP RRC */
    } else if (values.program === '1' && values.clientrrcoverallgrossearningsytd.length < 1) {
        errors.clientrrcoverallgrossearningsytd = 'Required';
        errors.notifyFormErrors = 'Discharge / Termination Tab - (RRC) Client Overall Gross Earnings YTD - Required';
        throw errors;
    } else if (values.program === '1' && !/[0-9999]$/g.test(values.clientrrcoverallgrossearningsytd)) {
        errors.clientrrcoverallgrossearningsytd = 'Required';
        errors.notifyFormErrors = 'Discharge / Termination Tab - (RRC) Client Overall Gross Earnings YTD - Required';
        throw errors;
    
  /*** Name Tab */
  } else if (!values.regid) {
    errors.regid = 'Required';
    errors.notifyFormErrors = 'Reg Id Required';
    throw errors;
  } else if (!values.fname) {
    errors.fname = 'Required';
    errors.notifyFormErrors = 'First Name Required';
    throw errors;
  } else if (!values.lname) {
    errors.lname = 'Required';
    errors.notifyFormErrors = 'Last Name Required';
    throw errors;
  } else if (!values.dob) {
    errors.dob = 'Required';
    errors.notifyFormErrors = 'Date of Birth Required';
    throw errors;

  /*** All Program Details */
  /*** Conditions */
  } else if (
    (values.clienthomelessna === 0 || values.clienthomelessna === false ) 
    &&
    (values.clienthomelesshistory === false || values.clienthomelesshistory === 0) 
    && 
    (values.clienthomelesscurrent === false || values.clienthomelesscurrent === 0)
    )  {
      errors.homelessna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Client Conditions Tab - Homeless in past 12 months - Required';
      throw errors;
  } else if (
    (values.clientmentalhealthissuesna === 0 || values.clientmentalhealthissuesna === false ) 
    &&
    (values.clientmentalhealthissueshistory === false || values.clientmentalhealthissueshistory === 0) 
    && 
    (values.clientmentalhealthissuescurrent === false || values.clientmentalhealthissuescurrent === 0)
    )  {
      errors.mentalhealthissuesna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Client Conditions Tab - Behavioral / Mental Health Issues - Required';
      throw errors;
  } else if (
    (values.clientsubstanceusedisorderissuesna === 0 || values.clientsubstanceusedisorderissuesna === false ) 
    &&
    (values.clientsubstanceusedisorderissueshistory === false || values.clientsubstanceusedisorderissueshistory === 0) 
    && 
    (values.clientsubstanceusedisorderissuescurrent === false || values.clientsubstanceusedisorderissuescurrent === 0)
    )  {
      errors.substanceusedisorderissuesna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Client Conditions Tab - Substance Use Disorder - Required';
      throw errors;
  } else if (
    (values.clientcooccurringna === 0 || values.clientcooccurringna === false ) 
    &&
    (values.clientcooccurringhistory === false || values.clientcooccurringhistory === 0) 
    && 
    (values.clientcooccurringcurrent === false || values.clientcooccurringcurrent === 0)
    )  {
      errors.cooccurringna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Client Conditions Tab - Co-occurring Disorders - Required';
      throw errors;
  } else if (
    (values.clientemployedduringpastna === 0 || values.clientemployedduringpastna === false ) 
    &&
    (values.clientemployedduringpasthistory === false || values.clientemployedduringpasthistory === 0) 
    && 
    (values.clientemployedduringpastcurrent === false || values.clientemployedduringpastcurrent === 0)
    )  {
      errors.employedduringpastna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Client Conditions Tab - Employed in past 12 months - Required';
      throw errors;

                                                  
    }
    

  return errors;
};
export default validateFields;








                                                                  // } else if (!values.clientadulteducationcomments) {
                                                                  //   errors.clientadulteducationcomments = 'Required';
                                                                  //   errors.notifyFormErrors = 'Voluntary Program Activities Tab - Client Adult Education Comments - Required';
                                                                  //   throw errors;


                                                                        // } else if (values.clientdischargedate && !values.clientdischargestatuscomments) {
                                                                        //   errors.clientdischargestatuscomments = 'Required';
                                                                        //   errors.notifyFormErrors = 'Discharge / Termination Tab - Client Discharge Status Comments - Required';
                                                                        //   throw errors;




                                                                      /*** Programs */
                                                                      /*** BOP RRC */
                                                                      //  // } else if (values.program === '1' && !values.bopsupervisingofficercomments ) {
                                                                      // } else if (values.program === 1 && !values.bopsupervisingofficercomments ) {
                                                                      //   errors.bopsupervisingofficercomments = 'Required';
                                                                      //   errors.notifyFormErrors = 'Programs Tab - BOP Officer Tab - BOP RRC - REQUIRES - BOP Supervising Officer Assigned - Details';
                                                                      //   throw errors;
                                                                      // // } else if (values.program === '1' && !values.bopinstitutioncomments ) {
                                                                      // } else if (values.program === 1 && !values.bopinstitutioncomments ) {
                                                                      //     errors.bopinstitutioncomments = 'Required';
                                                                      //     errors.notifyFormErrors = 'Programs Tab - BOP Institution Tab - BOP RRC - REQUIRES - BOP Institution Comments';
                                                                      //     throw errors;
                                                                      // // } else if (values.program === '1' && !values.bopgangaffiliationcomments ) {      
                                                                      // } else if (values.program === 1 && !values.bopgangaffiliationcomments ) {      
                                                                      //     errors.bopgangaffiliationcomments = 'Required';
                                                                      //     errors.notifyFormErrors = 'Programs Tab - BOP Gang Affiliation Tab - BOP RRC - REQUIRES - BOP Gang Affiliation Comments';
                                                                      //     throw errors;

                                                                      /*** OP Custs Psy */
                                                                      // // } else if (values.program === '4' && !values.opcusptspsyofficercomments ) {      
                                                                      // } else if (values.program === 4 && !values.opcusptspsyofficercomments ) {      
                                                                      //   errors.opcusptspsyofficercomments = 'Required';
                                                                      //   errors.notifyFormErrors = 'Programs Tab - OPC US PTS-Psy Officer Tab - OPC US PTS-Psy - REQUIRES - OPC US PTS-Psy Officer Assigned - Details';
                                                                      //   throw errors;


